 import excelJS from 'exceljs'
 import { save } from 'save-file'
 
 const downloadResultsExcel = async ({fileName,data}) => {
    const workbook = new excelJS.Workbook()

    workbook.views = [
      {
        x: 0, y: 0, width: 3, height: 1000,
        firstSheet: 0, activeTab: 1, visibility: 'visible'
      }
    ]

    const font = { name: 'Courier', size: 12, bold: true }

    const passes_worksheet = workbook.addWorksheet("passes")

    passes_worksheet.getColumn(1).width = 25
    passes_worksheet.getColumn(2).width = 100
    passes_worksheet.getColumn(3).width = 1000

    const passes_row = passes_worksheet.getRow(1)

    passes_row.getCell(1).value = "Pass ID"
    passes_row.getCell(2).value = "Apple URl"
    passes_row.getCell(3).value = "Google Url"
    passes_row.getCell(4).value = "Error"
    

    passes_row.getCell(1).font = font
    passes_row.getCell(2).font = font
    passes_row.getCell(3).font = font
    passes_row.getCell(4).font = font

    data.map((r, i) => {
      const row = passes_worksheet.getRow(i + 2)
      row.getCell(1).value = r.id
      row.getCell(2).value = r.appleUrl
      row.getCell(3).value = r.googleUrl
      row.getCell(4).value = r.error
      
      row.getCell(1).font = font
      row.getCell(2).font = font
      row.getCell(3).font = font
      row.getCell(4).font = font
    })

    const buffer = await workbook.xlsx.writeBuffer()

    await save(buffer, fileName + '.xlsx')
  }

  export default downloadResultsExcel